import { render, staticRenderFns } from "./VQOption.vue?vue&type=template&id=4d027240&scoped=true"
import script from "./VQOption.vue?vue&type=script&lang=js"
export * from "./VQOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d027240",
  null
  
)

export default component.exports